import { render, staticRenderFns } from "./itemsCounters.vue?vue&type=template&id=fb4339de&"
import script from "./itemsCounters.vue?vue&type=script&lang=js&"
export * from "./itemsCounters.vue?vue&type=script&lang=js&"
import style0 from "./itemsCounters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports